/**!*******************************************************************
 *
 * Copyright (c) Epic AI GmbH. All rights reserved.
 * Author:  Alexander Claas
 *
 ********************************************************************!*/

import { fetchCloudRun } from "../Helper";

/**
 * Get all chatbots that the user can access
 */
export const getAllBots = async (): Promise<IChatbotResult[]> => {
  const bots = await fetchCloudRun(
    process.env.VUE_APP_BASE_URL + "/bot/chatbots",
    "GET"
  );
  return bots.result as IChatbotResult[];
};
export interface IChatbotResult {
  name: string;
  organization?: string;
  id: string;
  owner: string;
}
